import { render, staticRenderFns } from "./wzvz_remark.vue?vue&type=template&id=15c6d980&scoped=true"
import script from "./wzvz_remark.vue?vue&type=script&lang=js"
export * from "./wzvz_remark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c6d980",
  null
  
)

export default component.exports